/**
 * @readonly
 * @enum {string}
 */
export const SevenDayRulesStatus = Object.freeze({
    PENDING: 'PENDING',
    DUE_SOON: 'DUE_SOON',
    DUE: 'DUE',
    OVERDUE: 'OVERDUE',
    CONVERTED: 'CONVERTED',
    NONE: 'NONE'
})
